module.exports = __webpack_public_path__ + "assets/TB_Dashboard_Icon_arrow_back-24px.svg";